import { DETERMINAR_PAGINA_ATUAL_ITINERARIO } from '../types'

export default function determinarPaginaAtualItinerario (paginaAtual) {
  return {
    type: DETERMINAR_PAGINA_ATUAL_ITINERARIO,
    payload: paginaAtual
  }
}
